import 'react-horizontal-scrolling-menu/dist/styles.css';

import {Box, BoxProps} from '@chakra-ui/react';
import {ScrollMenuArrow} from 'components/shared';
import React, {FC} from 'react';
import {ScrollMenu} from 'react-horizontal-scrolling-menu';
import {hiddenHorizontalScroll} from 'theme';

interface ScrollingMenuParams {
  zIndex?: number;
  children: any;
  sx?: BoxProps['sx'];
}

export const ScrollingMenu: FC<ScrollingMenuParams> = React.memo(({children, zIndex, sx}) => {
  // const hasArrows = Array.isArray(children) && children.length > 0 && children[0].length >= 5;
  const hasArrows = Array.isArray(children) && children.length > 0 && (children.length | children[0].length) >= 5;
  const Right = React.useMemo(
    () => (hasArrows ? <ScrollMenuArrow variant="right" zIndex={zIndex} /> : null),
    [hasArrows, zIndex],
  );
  const Left = React.useMemo(
    () => (hasArrows ? <ScrollMenuArrow variant="left" zIndex={zIndex} /> : null),
    [hasArrows, zIndex],
  );

  return (
    <Box position="relative" sx={{...hiddenHorizontalScroll, ...sx}}>
      {/* Lower ratio for smoother scrolling and better arrow visibility behavior */}
      <ScrollMenu RightArrow={Right} LeftArrow={Left} itemClassName="provider-scroll-item" options={{ratio: 0.09}}>
        {children}
      </ScrollMenu>
    </Box>
  );
});
